import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateRange'
})
export class DateRangePipe implements PipeTransform {
  transform(dates: Date[]): string {
    if (!dates || dates.length !== 2) {
      return '';
    }

    const startDate = dates[0];
    const endDate = dates[1];

    if (!startDate || !endDate) {
      return '';
    }

    const formattedStartDate = this.formatDate(startDate);
    const formattedEndDate = this.formatDate(endDate);

    if (this.isSameMonth(startDate, endDate)) {
      return `${startDate.getDay()} - ${formattedEndDate}`;
    } else {
      return `${formattedStartDate} - ${formattedEndDate}`;
    }
  }

  private formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    };
    return new Intl.DateTimeFormat('en-IE', options).format(date);
  }

  private isSameMonth(date1: Date, date2: Date): boolean {
    return date1.getMonth() === date2.getMonth();
  }
}
